(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-add-to-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('.floating-cart-section');
  if (!section) return;

  const switchEl = section.querySelector('#cart-button-switch');
  if (!switchEl) return;

  const mq = window.matchMedia('(max-width: 768px)');
  const HYSTERESIS = 48;
  let fixmeTop = 0;
  let isActive = false;
  let ticking = false;

  function measureThreshold() {
    fixmeTop = switchEl.getBoundingClientRect().top + window.scrollY;
  }

  function setActive(next) {
    if (isActive === next) return;
    isActive = next;
    section.classList.toggle('has-sticky-atc', next);
  }

  function updateStickyAtcState() {
    if (!mq.matches) {
      setActive(false);
      return;
    }

    const scrollY = window.scrollY;

    if (!isActive && scrollY >= fixmeTop) {
      setActive(true);
    } else if (isActive && scrollY < fixmeTop - HYSTERESIS) {
      setActive(false);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateStickyAtcState();
      ticking = false;
    });
  }

  measureThreshold();
  updateStickyAtcState();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    measureThreshold();
    updateStickyAtcState();
  });
  mq.addEventListener('change', function () {
    measureThreshold();
    updateStickyAtcState();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["points-earned"] && !Shopify.designMode) return;
  try {
    
  // No JavaScript needed for this example

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-kit-family-picker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initKitFamilyPicker = () => {
      document.querySelectorAll('[data-kit-family-picker]').forEach((section) => {
        const toggle = section.querySelector('[data-kit-family-toggle]');
        const toggleText = section.querySelector('[data-kit-family-toggle-text]');
        const details = section.querySelector('[data-kit-family-details]');
        const panel = section.querySelector('[data-kit-family-panel]');
        const closeBtn = section.querySelector('[data-kit-family-close]');
        if (!toggle || !toggleText || !details || toggle.dataset.ready === 'true') return;

        const collapsedText = toggleText.textContent;
        const expandedText = 'Hide Details';
        const mobileQuery = window.matchMedia('(max-width: 589px)');

        const setCompareOpen = (isOpen) => {
          toggle.setAttribute('aria-expanded', String(isOpen));
          details.hidden = !isOpen;
          section.classList.toggle('pkfp-compare-open', isOpen);
          document.documentElement.classList.toggle('pkfp-modal-lock', isOpen && mobileQuery.matches);
          toggleText.textContent = isOpen ? expandedText : collapsedText;
        };

        toggle.addEventListener('click', () => {
          const willExpand = toggle.getAttribute('aria-expanded') !== 'true';
          setCompareOpen(willExpand);
        });

        if (closeBtn) {
          closeBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            setCompareOpen(false);
          });
        }

        details.addEventListener('click', (event) => {
          if (mobileQuery.matches && event.target === details) {
            setCompareOpen(false);
          }
        });

        if (panel) {
          panel.addEventListener('click', (event) => {
            if (event.target.closest('[data-kit-family-close]')) return;
            event.stopPropagation();
          });
        }

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
            setCompareOpen(false);
          }
        });

        mobileQuery.addEventListener('change', () => {
          document.documentElement.classList.toggle(
            'pkfp-modal-lock',
            toggle.getAttribute('aria-expanded') === 'true' && mobileQuery.matches
          );
        });

        toggle.dataset.ready = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKitFamilyPicker);
    } else {
      initKitFamilyPicker();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-meta-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProductMetaDescriptions = () => {
      document.querySelectorAll('[data-product-meta-description]').forEach((section) => {
        const source = section.querySelector('.pmd-source');
        const target = section.querySelector('[data-pmd-generated]');

        if (!source || !target || target.dataset.ready === 'true') return;

        const highlightQty = (html) => (html || '').replace(/(\[X\d+\])/g, '<span class="pmd-qty">$1</span>');

        const getExplicitItemImage = (item) => {
          const itemImage = item.getAttribute('data-pmd-image');
          if (itemImage) return itemImage;

          const imageNode = item.querySelector('[data-pmd-image], img[data-pmd-hero]');
          if (!imageNode) return '';

          return imageNode.getAttribute('data-pmd-image')
            || imageNode.getAttribute('src')
            || imageNode.getAttribute('data-src')
            || '';
        };

        const sourceSections = Array.from(source.querySelectorAll('.video-text--section'));
        const groups = sourceSections.map((sourceSection) => {
          const titleNode = sourceSection.querySelector('.icon_text--title');
          const title = titleNode ? titleNode.textContent.trim() : '';
          const heroImage = sourceSection.querySelector('.video-element--poster img, .video-text__video video');
          const heroSrc = heroImage ? heroImage.getAttribute('src') || heroImage.getAttribute('poster') : '';
          const items = Array.from(sourceSection.querySelectorAll('.icon_text--inner')).map((item) => {
            const itemTitle = item.querySelector('.icon_text--content h4');
            const details = item.querySelector('.icon_text--content');
            const thumb = item.querySelector('.icon_text--icon img');

            const detailsHtml = details
              ? Array.from(details.children)
                .filter((node) => node.tagName !== 'H4')
                .map((node) => node.outerHTML)
                .join('')
              : '';

            return {
              titleHtml: itemTitle ? highlightQty(itemTitle.innerHTML) : '',
              detailsHtml: highlightQty(detailsHtml),
              thumbSrc: thumb ? thumb.getAttribute('src') : '',
              heroSrc: getExplicitItemImage(item) || heroSrc
            };
          }).filter((item) => item.titleHtml && item.detailsHtml);

          return { title, items };
        }).filter((group) => group.title && group.items.length);

        if (!groups.length) {
          source.hidden = false;
          target.remove();
          return;
        }

        const heading = document.createElement('h2');
        heading.className = 'pmd-title';
        heading.textContent = "What’s Included?";

        const header = document.createElement('div');
        header.className = 'pmd-header';

        const tabs = document.createElement('div');
        tabs.className = 'pmd-tabs';
        tabs.setAttribute('role', 'tablist');
        tabs.setAttribute('aria-label', "What’s included categories");

        const grid = document.createElement('div');
        grid.className = 'pmd-grid';

        const carousel = document.createElement('div');
        carousel.className = 'pmd-carousel';

        const prevButton = document.createElement('button');
        prevButton.type = 'button';
        prevButton.className = 'pmd-carousel-nav pmd-carousel-nav--prev';
        prevButton.setAttribute('aria-label', 'Previous product');
        prevButton.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 10 29"><path d="M8 26 2 14.5 8 3" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        const nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'pmd-carousel-nav pmd-carousel-nav--next';
        nextButton.setAttribute('aria-label', 'Next product');
        nextButton.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 10 29"><path d="M2 3l6 11.5L2 26" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        const dots = document.createElement('div');
        dots.className = 'pmd-carousel-dots';
        dots.setAttribute('aria-hidden', 'true');

        const mobileQuery = window.matchMedia('(max-width: 589px)');

        const getActiveIndex = () => {
          const slideWidth = grid.clientWidth;
          return slideWidth > 0 ? Math.round(grid.scrollLeft / slideWidth) : 0;
        };

        const updateDots = () => {
          if (!mobileQuery.matches) return;

          const dotItems = Array.from(dots.children);
          const activeIndex = Math.min(Math.max(getActiveIndex(), 0), dotItems.length - 1);
          dotItems.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activeIndex);
          });
        };

        const goToSlide = (index) => {
          if (!mobileQuery.matches) return;

          const dotItems = Array.from(dots.children);
          const cappedIndex = Math.min(Math.max(index, 0), dotItems.length - 1);
          grid.scrollTo({
            left: cappedIndex * grid.clientWidth,
            behavior: 'smooth'
          });
        };

        const getGroupKey = (title) => title.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

        const renderCards = (groupIndex) => {
          const activeGroup = groups[groupIndex];
          const activeGroupKey = getGroupKey(activeGroup.title);
          const itemCount = activeGroup.items.length;
          let layout = 'grid';

          if (itemCount === 1) {
            layout = 'single';
          } else if (itemCount === 3) {
            layout = 'triple';
          }

          carousel.dataset.activeGroup = activeGroupKey;
          carousel.dataset.layout = layout;
          carousel.dataset.itemCount = String(itemCount);
          grid.innerHTML = '';
          dots.innerHTML = '';

          activeGroup.items.forEach((item, itemIndex) => {
            const card = document.createElement('article');
            card.className = 'pmd-card';

            const media = document.createElement('div');
            media.className = 'pmd-card-media';

            if (item.heroSrc) {
              const hero = document.createElement('img');
              hero.src = item.heroSrc;
              hero.alt = '';
              hero.loading = 'lazy';
              media.appendChild(hero);
            }

            let thumbWrap = null;
            if (item.thumbSrc) {
              thumbWrap = document.createElement('div');
              thumbWrap.className = 'pmd-card-thumb';
              const thumb = document.createElement('img');
              thumb.src = item.thumbSrc;
              thumb.alt = '';
              thumb.loading = 'lazy';
              thumbWrap.appendChild(thumb);

              if (layout === 'single') {
                thumbWrap.classList.add('pmd-card-thumb--inline');
              } else {
                media.appendChild(thumbWrap);
              }
            }

            const body = document.createElement('div');
            body.className = 'pmd-card-body';
            body.innerHTML = `<h3 class="pmd-card-title">${item.titleHtml}</h3>${item.detailsHtml}`;

            if (layout === 'single' && thumbWrap) {
              body.prepend(thumbWrap);
            }

            card.append(media, body);
            grid.appendChild(card);

            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'pmd-carousel-dot';
            if (itemIndex === 0) dot.classList.add('is-active');
            dot.addEventListener('click', () => {
              goToSlide(itemIndex);
            });
            dots.appendChild(dot);
          });

          grid.scrollTo({ left: 0, behavior: 'auto' });
          updateDots();
        };

        groups.forEach((group, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pmd-tab';
          button.textContent = group.title;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-selected', 'false');
          button.addEventListener('click', () => {
            tabs.querySelectorAll('.pmd-tab').forEach((tab) => {
              tab.classList.remove('is-active');
              tab.setAttribute('aria-selected', 'false');
            });
            button.classList.add('is-active');
            button.setAttribute('aria-selected', 'true');
            renderCards(index);
          });
          tabs.appendChild(button);
        });

        carousel.append(grid, prevButton, nextButton, dots);
        header.append(heading, tabs);
        target.append(header, carousel);
        target.dataset.ready = 'true';

        prevButton.addEventListener('click', () => {
          goToSlide(getActiveIndex() - 1);
        });

        nextButton.addEventListener('click', () => {
          goToSlide(getActiveIndex() + 1);
        });

        let ticking = false;
        grid.addEventListener('scroll', () => {
          if (!mobileQuery.matches || ticking) return;

          ticking = true;
          window.requestAnimationFrame(() => {
            updateDots();
            ticking = false;
          });
        }, { passive: true });

        mobileQuery.addEventListener('change', () => {
          if (!mobileQuery.matches) {
            grid.scrollTo({ left: 0, behavior: 'auto' });
            return;
          }

          updateDots();
        });

        const defaultIndex = Math.max(0, groups.findIndex((group) => group.title.toLowerCase() === 'shelter'));
        const defaultTab = tabs.children[defaultIndex];
        if (defaultTab) defaultTab.click();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductMetaDescriptions);
    } else {
      initProductMetaDescriptions();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
